import { FieldValues, UseControllerProps, useFormContext } from 'react-hook-form';

import { DatePickerControl } from '../DatePickerControl';
import { IDatePickerControlProps } from '../DatePickerControl/types';

interface IDatePickerFromProps extends IDatePickerControlProps {
  fieldNameTo: string;
}

export const DatePickerFrom = <T extends FieldValues>(props: UseControllerProps<T> & IDatePickerFromProps) => {
  const { fieldNameTo, ...restProps } = props;
  const { setValue } = useFormContext();

  const fieldChangeHandler = () => setValue(fieldNameTo, '');

  return <DatePickerControl {...restProps} onChange={fieldChangeHandler} />;
};
